import { Container } from "@mui/material"
import { useDemand } from "lib/authorization/use-demand"
import { TieredAccessGate } from "minimals-template/components/guards/tiered-access-gate"

const productBodyText = [
    "Optimiser is available as a Pro add-on.",
    "Contact your Account Manager, contact us on +44 1768 720736 or sales@sfg20.co.uk",
]

const permissionBodyText = [
    "Your account includes Optimiser, but your user role does not include access to this area.",
    "Ask a client administrator to grant Optimiser access in User Roles.",
]

export function OptimiserAccessGate({ children, productDemand, demands = [] }) {
    const routeDemands = normalizeDemands(demands)
    const productDemands = ["user", "!sharing", productDemand]
    const hasProductAccess = useDemand(productDemands, true)
    const hasRouteAccess = useDemand([...productDemands, ...routeDemands], true)

    if (hasRouteAccess) {
        return <>{children}</>
    }

    if (hasProductAccess) {
        return renderGate("Optimiser access", permissionBodyText)
    }

    return renderGate("Optimiser", productBodyText)
}

function renderGate(title, bodyText) {
    return (
        <Container>
            <TieredAccessGate title={title} bodyText={bodyText} logEvent="optimiser" />
        </Container>
    )
}

function normalizeDemands(demands) {
    if (Array.isArray(demands)) return demands
    return [demands]
}
